import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Document } from 'types';
import NoItemsAvailable from 'modules/_shared/components/EmptyStates/NoItemsAvailable';

import DocumentsTableRow from './DocumentsTableRow';

type DocumentsTableBodyProps = {
  documents: Document[];
  handleRemoveDocument?: (document: Document) => void;
  handleReplaceDocument?: (document: Document) => void;
};

const DocumentsTableBody: FC<DocumentsTableBodyProps> = ({
  documents,
  handleRemoveDocument,
  handleReplaceDocument,
}) => {
  const { t } = useTranslate();

  const hasData = documents && documents.length > 0;
  return (
    <tbody>
      {hasData ? (
        documents?.map((document: Document, index: number) => (
          <tr className="nk-tb-item" key={`document-row-${document?._id}`}>
            <DocumentsTableRow
              index={index}
              document={document}
              handleRemoveDocument={handleRemoveDocument}
              handleReplaceDocument={handleReplaceDocument}
            />
          </tr>
        ))
      ) : (
        <NoItemsAvailable mainMessage={t('NoDocumentsAvailable')} />
      )}
    </tbody>
  );
};

export default DocumentsTableBody;
